//
//
//
//
//
//
//
//
//

export default {
  name: 'flow',
  props: {
    orientation: {
      type: String,
      default: 'horizontal'
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/flow/flow.vue